import type { ConceptDef } from '../types';

export const mealtimeSteps: ConceptDef = {
  kind: 'sequenceTap',
  id: 'mealtime-steps',
  label: 'Mealtime Steps',
  category: 'Daily living',
  description: 'Tap mealtime steps in order.',
  config: {
    promptMode: 'AUDIO',
    sequences: [
      { label: 'Mealtime.', items: ['🍽 plate', '🍴 fork', '🥛 cup', '😋 eat', '🧹 clear'] },
    ],
  },
};
